import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from "react-redux";

import { NavLink, useParams } from 'react-router-dom';

import { Loader, Placeholder } from 'rsuite';

import ArchitectureServerEmployeeWorkDaysAddModal from './architectureServerEmployeeWorkDays_add';


import 'sweetalert/dist/sweetalert.css';

import SweetAlert from 'sweetalert-react';


import Popup from '../../../components/popup';

import {
    retrieve, trash
} from './actions/arcServerEmployeeWorkDays'

export default function ArchitectureServerEmployeeWorkDays() {
    const { server_id } = useParams();
    const server_employee_work_days_data = useSelector(state => state.ARCServerEmployeeWorkDaysReducer, shallowEqual);
    // console.log(server_employee_work_days_data)
    const [createModalVisibility, setCreateModalVisibility] = useState(false);

    let handleCreateModalVisibility = () => {
        setCreateModalVisibility(!createModalVisibility);
    }

    let updateParentState = () => {
        setCreateModalVisibility(!createModalVisibility);
    }
    const initial_single_data = {
        id: '',
        record_data: {}
    };
    const [single_data, setSingleData] = useState(initial_single_data);
    const [record_length, setRecordLength] = useState(10);
    const [page, setPage] = useState(0);
    const [showTrashAlert, setShowTrashAlert] = useState({ show: false });
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();

    const fetchEmployeeWorkDays = recordLength => {
        setLoading(true);
        let data = {
            server_id: server_id,
            limit: parseInt(recordLength),
            // last_id: '',
            // first_id: '',
            page: page,
        };
        dispatch(retrieve(data)).then((response) => {
            setLoading(false);
        });
    }
    useEffect(() => {
        fetchEmployeeWorkDays(record_length)
    }, []);

    let handleChange = (e) => {
        if (e.target.name == 'record_length') {
            setRecordLength(e.target.value);
            fetchEmployeeWorkDays(e.target.value)
        }
    }

    let handlePrev = () => {
        setLoading(true);
        let data = {
            server_id: server_id,
            limit: record_length,
            // last_id: '',
            // first_id: server_employee_work_days_data.data.first_id,
            page: page - 1
        };
        dispatch(retrieve(data)).then(() => {
            setPage(page > 0 ? page - 1 : page)
        });
    }
    let handleNext = () => {
        setPage((page <= (parseInt((server_employee_work_days_data && server_employee_work_days_data.data && server_employee_work_days_data.data.total ? server_employee_work_days_data.data.total : 1) / record_length) - 1)) ? page + 1 : (parseInt((server_employee_work_days_data && server_employee_work_days_data.data && server_employee_work_days_data.data.total ? server_employee_work_days_data.data.total : 1) / record_length) - 1));
        setLoading(true);
        setPage((
            page <= (
                parseInt((
                    server_employee_work_days_data &&
                        server_employee_work_days_data.data &&
                        server_employee_work_days_data.data.total ? server_employee_work_days_data.data.total : 1
                ) / record_length) + 1
            ))
            ? page + 1
            : page
        );
        let data = {
            server_id: server_id,
            limit: record_length,
            // last_id: server_employee_work_days_data.data.last_id,
            // first_id: '',
            page: page + 1
        };
        dispatch(retrieve(data)).then((response) => {
            setLoading(false)
        });
    }


    // console.log(server_employee_work_days_data);



    let handleEdit = (record) => {
        setSingleData(
            {
                sector_id: record.id,
                record_data: record
            }
        )
    }

    let handleShowTrashAlert = (uid) => {
        // console.log(showTrashAlert, uid)
        setShowTrashAlert({ uid: uid, show: !showTrashAlert.show });
    }

    let handleAlertResponse = () => {
        handleDelete();
    }

    let handleDelete = () => {
        setLoading(true);
        let data = {
            server_id: server_id,
            id: showTrashAlert.uid,
        };
        dispatch(trash(data)).then(() => {
            setLoading(true);
            data = {
                server_id: server_id,
                limit: record_length,
                page: page,
                // last_id: '',
                // first_id: '',
            };
            dispatch(retrieve(data)).then(() => {
                setLoading(false);
                setTimeout(() => {
                    setShowTrashAlert({ show: !showTrashAlert.show });
                }, 1000);
            });
        });
    }




    return (

        <>
            {loading ?
                <div>
                    <Placeholder.Paragraph rows={8} />
                    <Loader center content="loading" />
                </div>
                :
                <>
                    <div className="d-sm-flex justify-content-between align-items-center mb-4">
                        <h3 className="text-dark mb-0 mobile-theading-title">Server Employee Work Days</h3>
                    </div>
                    <div className="card shadow hidden-xs">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-6 text-nowrap">
                                    <div id="dataTable_length" className="dataTables_length" aria-controls="dataTable">
                                        <label className="form-label">Show&nbsp;
                                            <select className="d-inline-block form-select form-select-sm" name='record_length' defaultValue={record_length} onChange={handleChange}>
                                                <option value="10">10</option>
                                                <option value="25">25</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </select>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="table-responsive table mt-2" id="dataTable" role="grid" aria-describedby="dataTable_info">
                                <table className="table my-0" id="dataTable">
                                    <thead>
                                        <tr>
                                            <th>Staff</th>
                                            <th>Date</th>
                                            <th>Holiday</th>
                                            <th>Shift Start Time</th>
                                            <th>Shift End Time</th>
                                            <th>break_start_time</th>
                                            <th>Break End Time</th>
                                            <th style={{ width: "110px" }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            server_employee_work_days_data &&
                                                server_employee_work_days_data.data &&
                                                server_employee_work_days_data.data.work_days &&
                                                server_employee_work_days_data.data.work_days.length > 0 ?
                                                server_employee_work_days_data.data.work_days.map((val, index) => {
                                                    return (
                                                        <tr>
                                                            <td>{val.staff_id}</td>
                                                            <td>{val.date}</td>
                                                            <td>{val.holiday}</td>
                                                            <td>{val.shift_start_time}</td>
                                                            <td>{val.shift_end_time}</td>
                                                            <td>{val.break_start_time}</td>
                                                            <td>{val.break_end_time}</td>
                                                            <td>
                                                                {/* <button type='button' className='btn btn-light btn-sm mr-15' onClick={handleEdit}><i className="fas fa-edit"></i></button> */}
                                                                <button type='button' className='btn btn-light btn-sm mr-15' onClick={() => handleShowTrashAlert(val.id)}><i className="fas fa-trash fg-theme"></i></button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                                : ''
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <div className="row">
                                <div className="col-md-6 align-self-center">
                                    <p id="dataTable_info" className="dataTables_info" role="status" aria-live="polite">Total Records {server_employee_work_days_data && server_employee_work_days_data.data && server_employee_work_days_data.data.total ? server_employee_work_days_data.data.total : 0}</p>
                                </div>
                                <div className="col-md-6">
                                    <nav className="d-lg-flex justify-content-lg-end dataTables_paginate paging_simple_numbers">
                                        <ul className="pagination">
                                            {page ?
                                                <li className={page ? "page-item" : "page-item disabled"} onClick={handlePrev}><a className="page-link" aria-label="Previous" href="#"><span aria-hidden="true">«</span> Previous</a></li>
                                                : ''}
                                            {(page <= (parseInt((server_employee_work_days_data && server_employee_work_days_data.data && server_employee_work_days_data.data.total ? server_employee_work_days_data.data.total : 1) / record_length) - 1)) ?
                                                <li className={(page <= (parseInt((server_employee_work_days_data && server_employee_work_days_data.data && server_employee_work_days_data.data.total ? server_employee_work_days_data.data.total : 1) / record_length) - 1)) ? "page-item" : "page-item disabled"} onClick={handleNext}><a className="page-link" aria-label="Next" href="#">Next <span aria-hidden="true">»</span></a></li>
                                                : ''}
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                            <SweetAlert
                                show={showTrashAlert.show}
                                title=""
                                text="Are you sure you want to permanently delete this record?"
                                onCancel={() => handleShowTrashAlert(false)}
                                showCancelButton
                                onConfirm={handleAlertResponse}
                            />
                        </div>
                    </div>

                    <div className="container-fluid shown-xs">
                        <div className="row">
                            <div className="col-md-12 text-nowrap">
                                <div id="dataTable_length" className="dataTables_length" aria-controls="dataTable">
                                    <label className="form-label">Show&nbsp;
                                        <select className="d-inline-block form-select form-select-sm" name='record_length' defaultValue={record_length} onChange={handleChange}>
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            {
                                server_employee_work_days_data &&
                                    server_employee_work_days_data.data &&
                                    server_employee_work_days_data.data.work_days &&
                                    server_employee_work_days_data.data.work_days.length > 0 ?
                                    server_employee_work_days_data.data.work_days.map((val, index) => {
                                        return (

                                            <div className="col-md-6 col-sm-6 col-xs-12 mt-2">
                                                <div className="row">
                                                    <div className="card shadow">
                                                        <div className="row">
                                                            <div className='card-header text-right'>
                                                                <button type='button' className='btn btn-light btn-sm mr-15 align-right' onClick={() => handleShowTrashAlert(val.id)}><i className="fas fa-trash fg-theme"></i></button>
                                                            </div>
                                                            <div className="card-body">
                                                                <p>Date: {val.date}</p>
                                                                <p>Staff : {val.staff_id}</p>
                                                                <p>Is Holiday : {val.holiday}</p>
                                                                <p>Shift Start Time : {val.shift_start_time}</p>
                                                                <p>Shift End Time : {val.shift_end_time}</p>
                                                                <p>Break Start Time : {val.break_start_time}</p>
                                                                <p>Break End Time : {val.break_end_time}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                    : ''
                            }
                        </div>
                        <div className="row mt-2">
                            <div className="col-md-12 align-self-center">
                                <p id="dataTable_info" className="dataTables_info text-center" role="status" aria-live="polite">Total Records {server_employee_work_days_data && server_employee_work_days_data.data && server_employee_work_days_data.data.total ? server_employee_work_days_data.data.total : 0}</p>
                            </div>
                            <div className="col-md-12">
                                <nav className="d-lg-flex justify-content-lg-end dataTables_paginate paging_simple_numbers">
                                    <ul className="pagination">
                                        {page ?
                                            <li className={page ? "page-item" : "page-item disabled"} onClick={handlePrev}><a className="page-link" aria-label="Previous" href="#"><span aria-hidden="true">«</span> Previous</a></li>
                                            : ''}
                                        {(page <= (parseInt((server_employee_work_days_data && server_employee_work_days_data.data && server_employee_work_days_data.data.total ? server_employee_work_days_data.data.total : 1) / record_length) - 1)) ?
                                            <li className={(page <= (parseInt((server_employee_work_days_data && server_employee_work_days_data.data && server_employee_work_days_data.data.total ? server_employee_work_days_data.data.total : 1) / record_length) - 1)) ? "page-item align-right" : "page-item align-right disabled"} onClick={handleNext}><a className="page-link" aria-label="Next" href="#">Next <span aria-hidden="true">»</span></a></li>
                                            : ''}
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </>
            }
        </>
    )
}
